import { createContext, useContext } from 'react'
import { type ProgramData } from '@terros/common'

type ProgramContextType = {
  program: ProgramData
  refetch: VoidFunction
  isFetching: boolean
}

export const ProgramContext = createContext<ProgramContextType | null>(null)

export const useProgramContext = (): ProgramContextType => {
  const context = useContext(ProgramContext)
  if (!context) {
    throw new Error('useProgramContext must be used within a ProgramContextProvider')
  }
  return context
}
